import { useQuery as useReactQuery } from 'react-query';
export default function useQuery(queryKey, queryFn, options) {
  return useReactQuery(queryKey, queryFn, options);
}